'use strict';

// Import Libraries
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { builderDispatch } from '../_utils/ui';
import ShelfEvents from '../_shelf-category/flux-events';
import translate from '../_utils/tools/translate';

const Favouritable = ({ favourited, designCode, showButtonText, loggedIn }) => {
  const iconClass = favourited ? 'selected fas fa-heart' : 'far fa-heart';

  const favouriteLabel = favourited
    ? `To Remove ${translate('Favourite')} from this design`
    : `${translate('Favourite')} this design`;

  const buttonText = showButtonText
    ? (favourited ? `Remove from ${translate('Favourites')}` : `Add to ${translate('Favourites')}`)
    : '';

  function openLoginPopup() {
    const url = App.order.login_path
      ? App.order.login_path.replace(/returnUrl.*$/, 'returnUrl=/login/go/back')
      : 'about:blank';

    const props = window.WK?.loginProps || {};
    const width = props.windowDimensions?.width || DEFAULT_POPUP_WIDTH;
    const height = props.windowDimensions?.height || DEFAULT_POPUP_HEIGHT;

    window.open(
      url,
      'login',
      `alwaysRaised=1,menubar=0,toolbar=0,location=0,personalbar=0,status=0,width=${width},height=${height}`,
    );
  }
  function toggleFavourite(e) {
    e.preventDefault();
    e.stopPropagation();

    builderDispatch.dispatch({
      type: loggedIn ? ShelfEvents.FAVOURITED : ShelfEvents.LOGGED_OUT_FAVOURITED,
      designCode,
    });
    if (!loggedIn) {
      openLoginPopup();
      return;
    }

    const data = new FormData();
    data.append('design_code', designCode);
    data.append('checked', !favourited);

    fetch('/favourites', {
      method: 'PUT',
      credentials: 'same-origin',
      body: data,
    });
  }

  if (!loggedIn) {
    return (
      <button
        className={classNames(
          'btn btn-link favouritable favouritable-sign-in',
          { 'd-flex justify-content-center': showButtonText }
        )}
        aria-label={favouriteLabel}
        onClick={toggleFavourite}
        role="button"
      >
        <i
          className={classNames(
            'float-right',
            { 'mr-2': showButtonText },
            iconClass
          )}
        />
        {buttonText && <span className="m-0 favouritable-text">{buttonText}</span>}
      </button>
    );
  }

  return (
    <button
      className={classNames(
        'btn btn-link favouritable',
        { 'd-flex justify-content-center': showButtonText }
      )}
      aria-label={favouriteLabel}
      onClick={toggleFavourite}
      role="checkbox"
      aria-checked={favourited}
    >
      <i
        className={classNames(
          'float-right',
          { 'mr-2': showButtonText },
          iconClass
        )}
      />
      {buttonText && <span className="m-0 favouritable-text">{buttonText}</span>}
    </button>
  );
};

Favouritable.displayName = 'Favouritable';

export default Favouritable;
